import React, {useEffect, useState} from 'react';
import {Button, Modal} from 'react-bootstrap';
import {bool, shape, func} from 'prop-types';
import assetModel from '../../model/asset';
import AssetEditForm from './AssetEditForm';
import usePrevious from '../../hooks/usePrevious';
import tagModel from '../../model/tag';
import {enrichTags} from '../misc/utils';
import {useTags} from '../../providers/TagsProvider';

const propTypes = {
  show: bool,
  asset: shape({}) || null,
  onChange: func,
  onHide: func.isRequired
};

const defaultProps = {
  show: true,
  asset: null,
  onChange: () => {}
};

const AssetEditModal = ({show, asset, onChange, onHide}) => {
  const [mutated, setMutated] = useState(false);
  const [working, setWorking] = useState(false);
  const [currentAsset, setCurrentAsset] = useState(asset ?? {});
  const [allTags, setAllTags] = useState([]);
  const {getTags, refreshTags, lastFetched} = useTags();

  const prevAsset = usePrevious(currentAsset);
  useEffect(() => {
    if (asset !== prevAsset && asset !== null) {
      if (allTags.length > 0) {
        asset.tags = enrichTags(allTags, asset.tags);
      }
      setCurrentAsset(asset);
    }
  }, [asset, allTags]);

  useEffect(() => {
    // Create an anonymous function and immediately call it to make use of await.
    // This is done because useEffect cant be async yet, so this is a workaround.
    (async () => {
      const tags = await getTags();
      setAllTags(tags);
      if (currentAsset !== null) {
        currentAsset.tags = enrichTags(tags, currentAsset.tags);
        setCurrentAsset(currentAsset);
      }
    })();
  }, [lastFetched]);

  const handleChange = (asset) => {
    setCurrentAsset(asset);
    setMutated(true);
  };

  const handleSave = async (e) => {
    e.preventDefault();

    setWorking(true);

    try {
      const updatedAsset = await assetModel.save(currentAsset);
      onChange(updatedAsset);
    } catch (e) {
      console.error(e);
    } finally {
      setWorking(false);
    }
  };

  const createNewTag = async (newTag) => {
    const newlyCreatedTag = await tagModel.create(newTag);

    refreshTags();

    return newlyCreatedTag;
  };

  return (
    <div>
      <Modal
        show={show}
        backdrop={true}
        onHide={onHide}
      >
        <Modal.Header closeButton={true}>
          <Modal.Title>Endre filressurs</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <AssetEditForm
            disabled={working}
            asset={currentAsset}
            onChange={handleChange}
            onSubmit={handleSave}
            tags={allTags}
            createNewTag={createNewTag}
          />
        </Modal.Body>

        <Modal.Footer>
          <Button
            onClick={onHide}
            disabled={working}
          >
                Lukk
          </Button>
          <Button
            onClick={handleSave}
            bsStyle="primary"
            disabled={working || !mutated}
          >
            {working &&
                 <span><i className="fa fa-spinner fa-pulse fa-fw"></i> Lagrer...</span>
            }
            {!working &&
                 <span>Lagre</span>
            }

          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

AssetEditModal.propTypes = propTypes;
AssetEditModal.defaultProps = defaultProps;

export default AssetEditModal;
